import { CATEGORIES } from '../../constants';
import { cn } from '../../utils/cn';

export default function Badge({ category, label, className }) {
  const config = CATEGORIES[category] || { label: label || category, color: 'bg-surface-200 text-navy-600' };
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold tracking-wide',
        config.color,
        className,
      )}
    >
      {config.dot && <span className={cn('w-1.5 h-1.5 rounded-full', config.dot)} />}
      {config.label}
    </span>
  );
}
